"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useLastVisitedProductsData;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _useDefaults = _interopRequireDefault(require("@sprinx/react-hooks/useDefaults"));

var _useResolveServiceActionName = _interopRequireDefault(require("@sprinx/react-api-client/useResolveServiceActionName"));

var _useServiceCall = _interopRequireDefault(require("@sprinx/react-api-client/useServiceCall"));

var _usePopulateProductHref = _interopRequireDefault(require("../../app/AppSettingsProvider/usePopulateProductHref"));

var _useLastVisitedProducts = _interopRequireDefault(require("../useLastVisitedProducts"));

function useLastVisitedProductsData(options) {
  var productsIds = (0, _useLastVisitedProducts.default)();

  var _React$useState = _react.default.useState([]),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      lastVisitedProducts = _React$useState2[0],
      setLastVisitedProducts = _React$useState2[1];

  var serviceName = (0, _useResolveServiceActionName.default)(null, 'v1.products.list'
  /* , serviceNames */
  );
  var populateProductHref = (0, _usePopulateProductHref.default)();
  var serviceCall = (0, _useServiceCall.default)((0, _useDefaults.default)(options, {
    clientCode: 'api',
    returnOnlyAction: true
  }), function (client, params) {
    return client.call(serviceName, params, {
      method: 'post'
    });
  });

  _react.default.useEffect(function () {
    serviceCall({
      query: {
        id: {
          $in: productsIds
        }
      }
    }).then(function (res) {
      setLastVisitedProducts(populateProductHref(res.rows || []));
    });
  }, [productsIds, serviceCall, populateProductHref]);

  return lastVisitedProducts;
}